import { StyleSheet } from 'aphrodite';
import { header } from '../../web/styles/colors';
import { BreakPoints } from '../../web/styles/styles';
import { MobileBreakpoint } from '../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {},
	errorMessage: {
		margin: 0,
	},
	labelWithIcon: {
		boxSizing: 'border-box',
		color: header,
		margin: 0,
		textWrap: 'wrap',
		marginTop: 10,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	meetingName: {
		fontSize: 18,
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			fontSize: 14,
		},
		textWrap: 'wrap',
	},
});
